"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var stimulus_1 = require("stimulus");
var DOWN_BUTTON_ELEMENT = "\n  <i class=\"fa fa-chevron-down pagesSyucchoKaitoriLp-CovidMeasures_ToggleButtonIcon\"/>\n  \u5404\u793E\u5B9F\u65BD\u4E2D\u306E\u5BFE\u7B56\u3092\u3082\u3063\u3068\u898B\u308B\n";
var UP_BUTTON_ELEMENT = "\n  <i class=\"fa fa-chevron-up pagesSyucchoKaitoriLp-CovidMeasures_ToggleButtonIcon\"/>\n  \u5404\u793E\u5B9F\u65BD\u4E2D\u306E\u5BFE\u7B56\u3092\u5C11\u306A\u304F\u8868\u793A\n";
var LIST_CLOSE_CLASS = 'pagesSyucchoKaitoriLp-CovidMeasures_CaseList-close';
var CovidMeasureController = /** @class */ (function (_super) {
    __extends(CovidMeasureController, _super);
    function CovidMeasureController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.connect = function () {
            if (!_this.listTarget) {
                return;
            }
            if (_this.data.has('collapsed')) {
                (0, jquery_1.default)(_this.listTarget).addClass(LIST_CLOSE_CLASS);
            }
        };
        _this.toggle = function () {
            if (!_this.listTarget || !_this.toggleButtonTarget) {
                return;
            }
            var listElement = (0, jquery_1.default)(_this.listTarget);
            var toggleButtonElement = (0, jquery_1.default)(_this.toggleButtonTarget);
            if (listElement.hasClass(LIST_CLOSE_CLASS)) {
                listElement.removeClass(LIST_CLOSE_CLASS);
                toggleButtonElement.html(UP_BUTTON_ELEMENT);
            }
            else {
                listElement.addClass(LIST_CLOSE_CLASS);
                toggleButtonElement.html(DOWN_BUTTON_ELEMENT);
            }
        };
        return _this;
    }
    CovidMeasureController.targets = ['list', 'toggleButton'];
    return CovidMeasureController;
}(stimulus_1.Controller));
exports.default = CovidMeasureController;
